const intialState = {
    types_entretien:[],
    contributions:[],
    echeances:[],
    initiatives:[],
    motifs_entretien:[],
    niveaux_formation:[],
    moyens_a_mobiliser:[],
    projet_pro_types_actions:[],
    types_validation_formation:[],

};

export default function reducer(state=intialState, action){

    switch (action.type){
        case "GET_PARAMS_FULFILLED":{
            return action.payload.data
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/params/_index.js